import Vue from 'vue'
/**
 * Directive v-safe-html
 *
 * Replace v-html with automatic sanitization via DOMPurify
 *
 * Usage:
 *   <div v-safe-html="userContent"></div>
 *   <div v-safe-html.strip="userContent"></div>  <!-- Removes all tags -->
 *   <div v-safe-html.allow-links="userContent"></div>  <!-- Allows <a> -->
 */

// Predefined configurations
const CONFIGS = {
	// Default: allows basic formatting tags
	default: {
		ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br', 'p', 'div', 'ul', 'ol', 'li'],
		ALLOWED_ATTR: ['class', 'style']
	},
	// Strip : removes all HTML tags
	strip: {
		ALLOWED_TAGS: [],
		ALLOWED_ATTR: []
	},
	// Allow-links : allows links
	allowLinks: {
		ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br', 'p', 'div', 'ul', 'ol', 'li', 'a'],
		ALLOWED_ATTR: ['class', 'style', 'href', 'target', 'rel']
	},
	// Rich : allows more tags (images, tables, headings, etc.)
	rich: {
		ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br', 'p', 'div', 'ul', 'ol', 'li', 'a', 'img', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre'],
		ALLOWED_ATTR: ['class', 'style', 'href', 'target', 'rel', 'src', 'alt', 'width', 'height']
	}
}

// Sanitization function
const sanitize = (html, modifiers = {}) => {
	if (!html) return ''

	let config = { ...CONFIGS.default }

	// Apply modifiers
	if (modifiers.strip) {
		config = { ...CONFIGS.strip }
	} else if (modifiers['allow-links'] || modifiers.allowLinks) {
		config = { ...CONFIGS.allowLinks }
	} else if (modifiers.rich) {
		config = { ...CONFIGS.rich }
	}

	// Always enforce link security
	config.ADD_ATTR = ['target']
	config.FORBID_ATTR = ['onerror', 'onload', 'onclick', 'onmouseover']

	return Vue.prototype.$sanitize(html, config)
}

// Vue Directive
const SafeHtmlDirective = {
	bind (el, binding) {
		el.innerHTML = sanitize(binding.value, binding.modifiers)
	},
	update (el, binding) {
		if (binding.value !== binding.oldValue) {
			el.innerHTML = sanitize(binding.value, binding.modifiers)
		}
	}
}

// Plugin d'installation
const SafeHtmlPlugin = {
	install (Vue) {
		Vue.directive('safe-html', SafeHtmlDirective)
	}
}

export default SafeHtmlPlugin
export { SafeHtmlDirective, sanitize }



// WEBPACK FOOTER //
// ./src/directives/safeHtml.js